import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Input } from 'antd';
import { Button, Col, Row } from '../../../components/ui';
import OpenBulkUnsubscribeButton from '../OpenBulkUnsubscribeButton';
import { joiResolver } from '@hookform/resolvers/joi';
import Joi from 'joi';
import { useUnsubscribeManually } from '../../../mutation/unsubscribe';

export default function ManualUnsubscribeForm() {
  const { isLoading, mutateAsync } = useUnsubscribeManually();
  const { control, formState, handleSubmit, reset } = useForm({
    defaultValues: { email: '' },
    resolver: joiResolver(
      Joi.object().keys({
        email: Joi.string().email({ tlds: false }),
      }),
    ),
    mode: 'onChange',
  });
  return (
    <>
      <p style={{ marginBottom: 5 }}>
        <b>Email address to unsubscribe </b>
      </p>
      <Row gutter={8}>
        <Col span={18}>
          <Controller
            control={control}
            name="email"
            render={({
              field: { value, onChange, onBlur },
              fieldState: { error },
            }) => {
              return (
                <Input
                  className={value && error ? 'error' : ''}
                  id="email-address"
                  name="email"
                  placeholder="abc@xyz.com"
                  style={{ fontSize: 13 }}
                  value={value}
                  onBlur={onBlur}
                  onChange={onChange}
                />
              );
            }}
          />
        </Col>
        <Col span={4}>
          <Button
            disabled={!formState.isValid || isLoading}
            id="unsubscribe-email"
            loading={isLoading}
            type="primary"
            onClick={handleSubmit(values => {
              mutateAsync(values).then(() => reset());
            })}
          >
            unsubscribe
          </Button>
        </Col>
      </Row>
      <p style={{ color: '#888', marginTop: 5 }}>
        Have multiple email addresses to unsubscribe?{'  '}
        <OpenBulkUnsubscribeButton>
          {({ onClick }) => (
            <span className="clickable" onClick={onClick}>
              Use Bulk Unsubscribe Widget
            </span>
          )}
        </OpenBulkUnsubscribeButton>
      </p>
    </>
  );
}
